import { Component, Vue } from 'vue-property-decorator';

@Component<Navigation>({
  components: {
  },
})
export default class Navigation extends Vue {
  protected isScrolled: boolean = false;

  public mounted() {
    //
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected logout() {
    this.$store.dispatch('setUser', null);
    this.$router.push('login');
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }
    
    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

  protected getUserImage() {
    if (!this.$store.state.user) return require('@/assets/images/profile.png');
    if (this.$store.state.user.picture) return this.$store.state.user.picture;
  }

  protected getStyle() {
    if (window.location.href.includes('par')) return 'par';
    else if (window.location.href.includes('esi')) return 'esi';
    else if (window.location.href.includes('bib')) return 'bib';
    else return '';
  }
}
